import styled from 'styled-components';

export const EditorContainer = styled.div<{ $noBorder?: boolean }>`
  ${({ theme, $noBorder }) =>
    !$noBorder && `border: 1px solid ${theme.token.colorBorderSecondary};`}
  position: relative;
  height: 100%;
  .copy_button {
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px;
    z-index: 1;
  }
`;
